module.exports = __webpack_public_path__ + "img/P26920580Kling.5ff03097.jpg";